module.exports = __webpack_public_path__ + "static/img/wx-qrcode.d354922.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index/wx-qrcode.jpg
// module id = g5Fp
// module chunks = 4